import { useContext, useMemo } from 'react';
import { getConfig } from '@bingads-webui-campaign/odata-config';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';

import { SmartPageUrlSuffix } from './smart-page-helpers';

const odataConfig = getConfig();

export function useSmartPageServiceContext() {
  const serverContext = useContext(ServerContext);

  const {
    CampaignAPIPath, // this value only exists in CCUI ServerContext
  } = serverContext;

  const path = CampaignAPIPath || odataConfig.odataPath;

  return useMemo(() => ({
    CurrentUser: serverContext.CurrentUser,
    CurrentAccount: serverContext.CurrentAccount,
    CurrentCustomer: serverContext.CurrentCustomer,
    CurrentLocale: serverContext.CurrentLocale,
    Permissions: serverContext.Permissions,
    CCUIPilots: serverContext.CCUIPilots,
    DynamicPermissions: serverContext.DynamicPermissions,
    CampaignAPIPath: path,
    ServicesEndpoints: serverContext.ServicesEndpoints,
    Token: serverContext.Token,
    PageTrackingId: serverContext.PageTrackingId,
    SmartPageUrlSuffix,
    Urls: serverContext.Urls,
    Omniture: serverContext.Omniture,
  }), [serverContext, path]);
}
